import { Trash2, Pencil, GripVertical } from "lucide-react";

export const PackageListItem = ({ pkg, onDragStart, onDragOver, onDrop, onEdit, onDelete }) => (
  <div
    draggable
    onDragStart={onDragStart}
    onDragOver={onDragOver}
    onDrop={onDrop}
    className="flex items-start justify-between border rounded px-4 py-3 cursor-move"
    data-testid={`admin-package-item-${pkg.id}`}
  >
    <div className="flex items-start gap-2">
      <GripVertical size={16} className="mt-1 text-muted-foreground shrink-0" />
      <div>
        <p className="text-sm font-medium">
          {pkg.name} — {pkg.hours}h{pkg.photos_count > 0 ? ` — ${pkg.photos_count} fotos` : ""}{pkg.videos_count > 0 ? ` — ${pkg.videos_count} videos` : ""}{pkg.clips_count > 0 ? ` — ${pkg.clips_count} clips` : ""}{pkg.video_master_count > 0 ? ` — ${pkg.video_master_count} Video Master` : ""} — ${Number(pkg.price).toLocaleString("es-MX")}
        </p>
        <p className="text-xs text-muted-foreground">{pkg.description}</p>
      </div>
    </div>
    <div className="flex gap-2 shrink-0">
      <button data-testid={`admin-package-edit-${pkg.id}`} onClick={onEdit}><Pencil size={16} /></button>
      <button data-testid={`admin-package-delete-${pkg.id}`} onClick={onDelete}><Trash2 size={16} /></button>
    </div>
  </div>
);
